import { ToggleGroup } from 'radix-ui';
import { type ReactNode, type RefAttributes, forwardRef } from 'react';

import { Count, CountContainer, Item, TabFilterContainer } from './styles';

export interface ITabProps extends ToggleGroup.ToggleGroupItemProps {
  children: ReactNode;
  dataCy?: string;
  status?: number | string;
}

export const Tab = forwardRef<HTMLButtonElement, ITabProps>(
  // eslint-disable-next-line no-restricted-syntax
  function Tab(
    { children, dataCy = 'tab', status = '', ...props },
    ref
  ): JSX.Element {
    return (
      <Item {...props} data-cy={dataCy} ref={ref}>
        {children}
        {status !== '' && (
          <CountContainer data-cy="tab-button-container">
            <Count data-cy="tab-indicator">{status}</Count>
          </CountContainer>
        )}
      </Item>
    );
  }
);

type IToggleGroup = RefAttributes<HTMLDivElement> &
  (ToggleGroup.ToggleGroupMultipleProps | ToggleGroup.ToggleGroupSingleProps);

export type ITabFilterGroupProps = IToggleGroup & {
  children: ReactNode;
  dataCy?: string;
};

export const TabFilterGroup = forwardRef<HTMLDivElement, ITabFilterGroupProps>(
  // eslint-disable-next-line no-restricted-syntax
  function TabFilterGroup(
    { children, dataCy = 'tab-group', ...props }: ITabFilterGroupProps,
    ref
  ): JSX.Element {
    return (
      <TabFilterContainer {...props} ref={ref} data-cy={dataCy}>
        {children}
      </TabFilterContainer>
    );
  }
);
